import axios from '../axios/axios'

export default {
  state: {
    reportData: [],
    isReportFormed: false
  },
  mutations: {
    loadReportData(state, reportData) {
      state.reportData = reportData
    },
    clearReportData(state) {
      state.reportData = []
    },
    changeIsReportFormed(state, status) {
      state.isReportFormed = status
    }
  },
  actions: {
    async fetchReportData({commit}, params) {
      try {
        commit('setLoading', true)
        const response = await axios.get('/reports', {params})
        commit('loadReportData', response.data.reportData)
        commit('changeIsReportFormed', true)
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    }
  },
  getters: {
    reportData(state) {
      return state.reportData
    },
    isReportFormed(state) {
      return state.isReportFormed
    }
  }
}
